
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/launchdarkly",
      function () {
        return require("private-next-pages/destinations/launchdarkly.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/launchdarkly"])
      });
    }
  